import {decodeBase64BigEndian, encodeBase64BigEndian, fillZeroL} from "../util/binary";
import cmpConfig from "../cmp-config";
import cookies from "services-comun/modules/browser/cookies";
import {
    CMP_CUS_CONSENT_COOKIE,
    CMP_CUS_CONSENT_LOCALKEY
} from "../cmp/cmp";

interface IVendorInfo {
    [key:number]:boolean;
}

export class CustomConsent {
    /* STATIC */
    public static buildProxy(encodedString?: string): CustomConsent {
        const customConsent: CustomConsent = new CustomConsent();
        if (encodedString) {
            const binaryString: string = decodeBase64BigEndian(encodedString);

            let remainBits: string = binaryString;

            // Versión
            const versionBits: string = binaryString.substring(0, 8);
            customConsent.version = parseInt(versionBits, 2);

            remainBits = remainBits.substring(8);

            // Vendors
            const vendorsBits: string = remainBits.substring(0, 100);
            const vendorsBitsLen: number = vendorsBits.length;
            for (let vendorId: number = 1; vendorId <= vendorsBitsLen; vendorId++) {
                const selected: boolean = vendorsBits.charAt(vendorId - 1) == '1';
                if (selected) customConsent.vendorInfo[vendorId] = true;
            }

        }
        customConsent.encodedStringExists = encodedString !== undefined;
        return customConsent;
    }

    /* INSTANCE */

    private encodedStringExists: boolean = false;

    private _version: number;
    private vendorInfo: IVendorInfo;

    private constructor() {
        this._version = cmpConfig.customStringVersion;
        this.vendorInfo = {};
    }

    public get version(): number {
        return this._version;
    }

    private set version(version: number) {
        this._version = version;
    }

    /**
     * Codifica en base64 la cadena binaria.
     * @private
     * @return Cadena en base64 con la cadena binaria.
     */
    private encode() : string {

        const version: string = fillZeroL(this.version.toString(2), 8);

        let addtlString:string = `${version}`;

        for (let vendorId:number=1;vendorId<=100;vendorId++) {
            addtlString += this.vendorInfo[vendorId] ? '1' : '0';
        }
        return encodeBase64BigEndian(addtlString);
    }

    /**
     * Genera la cadena decodificada.
     * @private
     * @return cadena decodificada.
     */
    public decodedString() : string {
        return `v${this.version};${Object.keys((this.vendorInfo)).map(key => parseInt(key)).join('.')}`;
    }

    /**
     * Genera la cadena codificada.
     */
    public encodedString() : string {
        return this.encode();
    }

    /**
     * Persiste la información de consentimiento personalizado.
     * @return True si se ha guardado correctamente, False en otro caso.
     */
    public save() : boolean {
        cookies.set(CMP_CUS_CONSENT_COOKIE, this.encode()||' ', new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)));
        this.loadLocalStorage();
        this.encodedStringExists = true;
        return true;
    }

    /**
     * Carga la información de la cookie en el localStorage decodificada.
     * @private
     */
    private loadLocalStorage() : void {
        localStorage.setItem(CMP_CUS_CONSENT_LOCALKEY, this.decodedString());
    }

    /**
     * Devuelve los IDs de vendors aceptados.
     */
    public vendorsIds() : number[] {
        return this.decodedString().split(';')[1].split('.').filter(idStr => !isNaN(parseInt(idStr))).map(idStr => parseInt(idStr));
    }

    public vendors(): IVendorInfo {
        return this.vendorInfo;
    }

    public update(vendorsIds:number[]) : void {
        this.vendorInfo = {};
        vendorsIds.forEach((vendorId: number) => {this.vendorInfo[vendorId] = true;});
    }

    public existsCustomConsentCookie() : boolean {
        return this.encodedStringExists;
    }
}
